import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectOrganization } from '../../../Actions/Login.action';
import { translate } from '../../../Services/translation';
import Select from '../../Select';

const LoginSelectOrganization = () => {
  const dispatch = useDispatch();
  const { organizations, isLoading } = useSelector((state) => state.login);

  // Sort once using useMemo
  const sortedOrganizations = useMemo(() => {
    return organizations?.slice().sort((a, b) => a.name.localeCompare(b.name)) || [];
  }, [organizations]);

  const [selectedOrganizationId, setSelectedOrganizationId] = useState("");

  useEffect(() => {
    if (sortedOrganizations.length > 0) {
      setSelectedOrganizationId(sortedOrganizations[0].value || sortedOrganizations[0].systemId);
    }
  }, [sortedOrganizations]);

  const handleSelectChange = (event) => {
    setSelectedOrganizationId(event.target.value);
  };

  const handleButtonClick = () => {
    if (selectedOrganizationId) {
      dispatch(selectOrganization(selectedOrganizationId));
    } else if (sortedOrganizations.length > 0) {
      dispatch(selectOrganization(sortedOrganizations[0].systemId));
    }
  };

  return sortedOrganizations.length > 0 ? (
    <>
      <Select
        label={translate('login.choose-organization')}
        id="organizationPicker"
        onChange={handleSelectChange}
        value={selectedOrganizationId}
        disabled={isLoading}
      >
        {sortedOrganizations.map((option, index) => (
          <option key={index} value={option.systemId}>
            {option.name}
          </option>
        ))}
      </Select>
      <button
        className="login__submit-button-organization"
        onClick={handleButtonClick}
        disabled={isLoading}
      >
        {!isLoading ? translate('general.select') : translate('general.loading')}
      </button>
    </>
  ) : null;
};

export default LoginSelectOrganization;
